import React, { useState, useEffect } from 'react'
import store from '../../store'
import { connect } from 'react-redux'
import CardList from './CardList'
import { renderSvg } from './renderSvg'
import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../actions/search-actions'
import Trip from '../pnrEnquiry/trip'
import BusPnr from '../pnrEnquiry/busPnr'
import Obr from '../pnrEnquiry/obr'
import Mobile from '../pnrEnquiry/mobile'
import Email from '../pnrEnquiry/Email'
import MobileEmail from '../pnrEnquiry/mobileEmail';
import { MANAGE_BUS_BOOKING, t } from '../../translations/ManageAccount/ManageAccount'
import { tCommon, BUS_PNR, BUS_SER, EMAIL_BASED, ENQ, MOBILE_BASED, OB_REF,MOBILE_EMAIL_BASED_ENQ } from '../../translations/Common'

const BusTicketBooking = ({ captchaToken, refreshCaptchaToken }) => {
    const [leftTabs, setLeftTabs] = useState(0)
    const urlParams = new URLSearchParams(window.location.search);
    const enquiry = urlParams.get("enquiry")

    //console.log("MANAGE_BUS_BOOKING", MANAGE_BUS_BOOKING);

    useEffect(() => {
        if (enquiry) {
            setLeftTabs(1);
        }
    }, [])

    return (
        <div className="mainContent">
            <div className="leftContent">
                <div className="leftTabs">
                    <div className={`tabsContent ${leftTabs == 0 && "active"}`} onClick={() => setLeftTabs(0)}>
                        {renderSvg("mitra")}
                        <span className="header-right-item-text">{t(MANAGE_BUS_BOOKING)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 1 && "active"}`} onClick={() => { setLeftTabs(1); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("pnr")}
                        <span className="header-right-item-text">{tCommon(BUS_PNR)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 2 && "active"}`} onClick={() => { setLeftTabs(2); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("currency")}
                        <span className="header-right-item-text">{tCommon(OB_REF)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    {/* <div className={`tabsContent ${leftTabs == 3 && "active"}`} onClick={() => { setLeftTabs(3); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("mobile")}
                        <span className="header-right-item-text">{tCommon(MOBILE_BASED)} <br /> {tCommon(ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 4 && "active"}`} onClick={() => { setLeftTabs(4); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("email")}
                        <span className="header-right-item-text">{tCommon(EMAIL_BASED)} <br /> {tCommon(ENQ)}</span>
                    </div> */}
                    <div className={`tabsContent ${leftTabs == 6 && "active"}`} onClick={() => { setLeftTabs(6); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("mobile")}
                        <span className="header-right-item-text">{tCommon(MOBILE_EMAIL_BASED_ENQ)}</span>
                    </div>
                    <div className={`tabsContent ${leftTabs == 5 && "active"}`} onClick={() => { setLeftTabs(5); store.dispatch(updatePnrEnqiryData(false)); store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} })) }}>
                        {renderSvg("service")}
                        <span className="header-right-item-text">{tCommon(BUS_SER)} <br /> {tCommon(ENQ)}</span>
                    </div>
                </div>
            </div>
            <div className="rightContent">
                {leftTabs == 0 && <CardList />}
                {leftTabs === 1 && (
                    <BusPnr
                        captchaToken={captchaToken}
                        refreshCaptchaToken={refreshCaptchaToken}
                    />
                )}
                {leftTabs === 2 && (
                    <Obr
                        captchaToken={captchaToken}
                        refreshCaptchaToken={refreshCaptchaToken}
                    />
                )}
                {/*leftTabs === 3 && <Mobile />*/}
                {/*leftTabs === 4 && <Email />*/}
                {leftTabs === 5 && <Trip />}
                {leftTabs === 6 && (
                    <MobileEmail
                        captchaToken={captchaToken}
                        refreshCaptchaToken={refreshCaptchaToken}
                    />
                )}
            </div>
        </div>
    )
}


const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(BusTicketBooking);